<template>
    <QrHeader :text="trans('header.goal-for-the-qr-code')" trans="header.goal-for-the-qr-code"/>

    <div class="gap-4 mt-4">
        <QrForm @submit.prevent="create" class="space-y-4">
            <QrRadio
                v-model="newQrCode.type"
                :options="[
                    { text: trans('option.i-want-to-point-to-a-website'), trans: 'option.i-want-to-point-to-a-website', value: 'webpage' },
                    { text: trans('option.i-want-to-create-a-home-page'), trans: 'option.i-want-to-create-a-home-page', value: 'homepage' },
                ]"
            />
            <QrInput
                v-if="newQrCode.type === 'webpage'"
                v-model="newQrCode.redirect_url"
                :label="trans('label.website')"
                trans="label.website"
                :errors="validationErrors.redirect_url"
            />
            <template v-else>
                <QrInput
                    v-model="newQrCode.homepage_title"
                    :label="trans('homepage.title')"
                    trans="homepage.title"
                    :placeholder="trans('homepage.title')"
                />
                <QrInput
                    v-model="newQrCode.homepage_sub_title"
                    :label="trans('homepage.sub-title')"
                    trans="homepage.sub-title"
                    :placeholder="trans('homepage.sub-title')"
                />
            </template>
        </QrForm>

        <div class="flex justify-between mt-4">
            <QrButton
                :to="backRoute"
                :text="trans('button.back')"
                trans="button.back"
                secondary
                icon="arrow-left"
            />

            <QrButton
                @click="create"
                :text="trans('button.continue')"
                trans="button.continue"
                icon-right="arrow-right"
                :disabled="!canContinue"
                :loading="loading"
                :recently-succeeded="recentlySucceeded"
            />
        </div>
    </div>
</template>

<script setup>
import { trans } from "@/libs/helper.js";
import QrInput from "@/components/application-ui/form/QrInput.vue";
import QrForm from "@/components/application-ui/content/QrForm.vue";
import QrHeader from "@/components/application-ui/content/QrHeader.vue";
import QrButton from "@/components/application-ui/elements/QrButton.vue";
import QrRadio from "@/components/application-ui/form/QrRadio.vue";
import { useQrCodesStore} from "@/store/qrCodes.js";
import { storeToRefs } from "pinia";
import { computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useStatesStore } from "@/store/states.js";

const router = useRouter();
const statesStore = useStatesStore();
const { loading, validationErrors, recentlySucceeded } = storeToRefs(statesStore);
const qrCodeStore = useQrCodesStore();
const { newQrCode, qrCode } = storeToRefs(qrCodeStore);

onMounted(() => {
    if (! newQrCode.value.name) {
        router.push('/create/product');
    }

    newQrCode.value.step = 2
});

const create = async () => {
    if (! canContinue.value) {
        return;
    }

    if (qrCode.value) {
        qrCode.value.name = newQrCode.value.name;
        qrCode.value.type = newQrCode.value.type;
        qrCode.value.redirect_url = newQrCode.value.redirect_url;
        qrCode.value.product_id = newQrCode.value.product_id;
        qrCode.value.homepage_title = newQrCode.value.homepage_title;
        qrCode.value.homepage_sub_title = newQrCode.value.homepage_sub_title;
        await qrCodeStore.update();
    } else {
        await qrCodeStore.create({
            name: newQrCode.value.name,
            type: newQrCode.value.type,
            redirect_url: newQrCode.value.redirect_url,
            product_id: newQrCode.value.product_id,
            homepage_title: newQrCode.value.homepage_title,
            homepage_sub_title: newQrCode.value.homepage_sub_title
        })
    }

    if (newQrCode.value.type === 'homepage') {
        await router.push(`/create/homepage/${qrCode.value.id}`)
    } else {
        await router.push(`/create/design/${qrCode.value.id}`)
    }
}

const canContinue = computed(() => {
    if (newQrCode.value.type === 'webpage') {
        return newQrCode.value.redirect_url
    }

    if (newQrCode.value.type === 'homepage') {
        return newQrCode.value.homepage_title
    }
});

const backRoute = computed(() => {
    if (qrCode.value) {
        return `/create/product/${qrCode.value.id}`;
    }

    return '/create/product';
});

</script>
